export class GenerationFailedError extends Error {
	public constructor(public cause?: unknown, message = 'Generation failed') {
		super(message);
		this.name = 'GenerationFailedError';
	}
}
